export enum ContractType {
  VisitPack = "VisitPack",
  FlexibleSubscription = "FlexibleSubscription",
  FlatSubscription = "FlatSubscription",
  PerVisitAccount = "PerVisitAccount",
}
